import React from 'react';

import * as styles from './ReviewCardPartnerLogo.styles';

interface ReviewCardPartnerLogoProps {
  /** The partner's logo. Nothing renders without one: no circle, no stand-in. */
  logoUrl?: string;
  /** The circle's diameter, from the design. Each card's reply is drawn at its own size. */
  size: string;
}

/**
 * The partner's logo, in a circle, beside their name.
 *
 * Decorative in every case: whatever sits next to it names the partner, so describing the
 * logo too would say it twice. A partner with no logo gets no circle rather than a stand-in
 * derived from their name, since the name is already there to read.
 *
 * Shared by both cards' replies, which draw the same circle at two sizes. That the logo is
 * decorative, and that nothing shows without one, are decisions worth stating once.
 */
export const ReviewCardPartnerLogo = ({ logoUrl, size }: ReviewCardPartnerLogoProps) => {
  if (!logoUrl) {
    return null;
  }

  return (
    <span
      aria-hidden
      css={styles.logo}
      style={{ [styles.LOGO_SIZE_VAR]: size } as React.CSSProperties}
    >
      <img
        alt=""
        css={styles.logoImage}
        data-testid="review-card-partner-logo"
        decoding="async"
        loading="lazy"
        src={logoUrl}
      />
    </span>
  );
};

ReviewCardPartnerLogo.displayName = 'ReviewCardPartnerLogo';
